import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { AuditoryRepository } from "@entity/data/repositories/auditory.repository";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteAuditoryUseCase {
    constructor(
        @inject(AuditoryRepository)
        private readonly auditoryRepository: AuditoryRepository,
    ) {}

    async execute(auditoryId: number): Promise<void> {
        const result = await this.auditoryRepository.delete(auditoryId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        ToastManagerStore.success();
    }
}
